import React, { useEffect, useRef } from 'react';

function CanvasLogo({ width = 500, height = 400, className = '' }) {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');

    // -----------------------------------
    // 1) Canvas + Basic Geometry
    // -----------------------------------
    canvas.width  = width;
    canvas.height = height;

    const scale = Math.min(width / 300, height / 300);

    const poleX      = width * 0.2;
    const poleYTop   = height * 0.15;
    const poleWidth  = 4 * scale;
    const poleHeight = height * 0.45;

    const flagLeftX   = poleX + poleWidth;
    const flagTopY    = poleYTop;
    const flagWidth   = width * 0.6;
    const flagHeight  = height * 0.4;
    const flagRightX  = flagLeftX + flagWidth;
    const flagBottomY = flagTopY + flagHeight;

    // -----------------------------------
    // 2) Lines of Text
    // -----------------------------------
    const hacktronText = `
You are Hacktron, a highly skilled software security researcher and top CTF player. The application you are analyzing can be either a CTF challenge or a real-world application.
The application you are analyzing can be either a CTF challenge or a real-world application. Your primary goal is to find vulnerabilities in the application and exploit them.
Your primary goal is to find vulnerabilities in the application and exploit them.If there is a flag present, you must retrieve it. You are Hacktron, a highly skilled softwar
If there is a flag present, you must retrieve it. You are Hacktron, a highly skilled software security researcher and top CTF player. The application you are analyzing can 
    `;

    const lines = hacktronText
      .split('\n')
      .map(line => line.trim())
      .filter(line => line.length > 0);

    function getRandomLine() {
      const i = Math.floor(Math.random() * lines.length);
      return lines[i];
    }

    const linesToRender = 3;
    const textLines = Array.from({ length: linesToRender }, getRandomLine);

    // -----------------------------------
    // 3) Animation Settings
    // -----------------------------------
    // Speed in px/ms => 0.1 means 100px/sec
    const scrollSpeedPxPerMs = 0.1;
    const waveSpeedPerMs     = 0.001;
    const waveAmplitude      = 3 * scale;
    const letterSpacing      = 8 * scale;
    const lineHeight         = 16 * scale;

    let marqueeX = 0; // current scroll offset
    let t        = 0; // wave time
    let lastTime = null;

    function drawFlag(timestamp) {
      // 1) Calculate time delta
      if (!lastTime) lastTime = timestamp;
      const delta = timestamp - lastTime;
      lastTime = timestamp;

      // 2) Clear
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      // 3) Draw pole
      const gradient = ctx.createLinearGradient(poleX, poleYTop, poleX, poleYTop + poleHeight);
      gradient.addColorStop(0, 'rgba(255, 255, 255, 0.95)');
      gradient.addColorStop(0.5, 'rgba(240, 240, 240, 0.95)');
      gradient.addColorStop(1, 'rgba(255, 255, 255, 0.95)');
      ctx.fillStyle = gradient;
      ctx.fillRect(poleX, poleYTop, poleWidth, poleHeight);

      // 4) Triangle clipping
      ctx.save();
      ctx.beginPath();
      ctx.moveTo(flagLeftX, flagTopY);
      ctx.lineTo(flagRightX, flagTopY + flagHeight * 0.5);
      ctx.lineTo(flagLeftX, flagBottomY);
      ctx.closePath();
      ctx.clip();

      // 5) Text style
      ctx.font = `${Math.max(8, 14 * scale)}px monospace`;
      ctx.shadowColor = 'rgba(200, 0, 0, 0.3)';
      ctx.shadowBlur  = 2 * scale;
      ctx.fillStyle   = '#ff3b30';

      // 6) Draw each line with “double-draw” for seamless wrap
      for (let row = 0; row < linesToRender; row++) {
        const lineStr   = textLines[row];
        const totalChars = lineStr.length;
        const lineBaseY  = flagTopY + 20 + row * lineHeight;

        for (let i = 0; i < totalChars; i++) {
          const char = lineStr[i];
          // Primary X
          const x1 = flagLeftX + marqueeX + (i * letterSpacing);
          // Second copy (immediately after the full length)
          const x2 = x1 + (totalChars * letterSpacing);

          // Wave offset
          const phase   = row * Math.PI / 4;
          const yOffset = Math.sin(t + i * 0.1 + phase) * waveAmplitude;
          const y       = lineBaseY + yOffset;

          // Draw both copies so text loops
          ctx.fillText(char, x1, y);
          ctx.fillText(char, x2, y);
        }
      }

      ctx.restore();

      // 7) Update offsets/time
      // Move left by scrollSpeedPxPerMs * delta
      marqueeX -= scrollSpeedPxPerMs * delta;

      // If we've scrolled one line length, reset so there's no gap
      // We'll just pick the length of the first line for a reference
      const firstLineCharCount = textLines[0].length;
      const lineWidthPx        = firstLineCharCount * letterSpacing;
      if (marqueeX < -lineWidthPx) {
        marqueeX += lineWidthPx;
      }

      // Wave time
      t += waveSpeedPerMs * delta;

      requestAnimationFrame(drawFlag);
    }

    // Kick off
    requestAnimationFrame(drawFlag);

    return () => {
      // If storing the animationFrame ID, you’d cancelAnimationFrame(...) here.
    };
  }, [width, height, className]);

  return (
    <canvas
      ref={canvasRef}
      className={className}
      style={{ width, height, display: 'block' }}
    />
  );
}

export default CanvasLogo;
